import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup } from 'react-bootstrap'

const FieldInput = ({ TypeOf, input, type, name, label, placeholder, meta: { touched, error, warning }, focus, inputGrup, defaultValue, isDisabled, handleChange,size }) => {
    return (
        <>
            <Form.Label htmlFor={name}>{label}</Form.Label>
            <InputGroup>
                {inputGrup ? <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroupPrepend">{inputGrup}</InputGroup.Text>
                </InputGroup.Prepend> : null}

                {
                    
                    !!handleChange ?

                        <TypeOf
                            autoFocus={focus}
                            {...input}
                            size={size}
                            type={type}
                            defaultValue={defaultValue}
                            name={name}
                            disabled={isDisabled}
                            placeholder={placeholder}
                            isInvalid={touched && (error || warning)}
                            onBlur={handleChange}
                        /> :
                        <TypeOf
                            autoFocus={focus}
                            {...input}
                            type={type}
                            defaultValue={defaultValue}
                            name={name}
                            disabled={isDisabled}
                            placeholder={placeholder}
                            isInvalid={touched && (error || warning)}
                        />

                }

            </InputGroup>
            {touched && ((error && <p className="text-danger">{error}</p>) || (warning && <p className="text-danger">{warning}</p>))}
            <Form.Control.Feedback type="invalid">
                {error}
            </Form.Control.Feedback>
        </>
    );
};

FieldInput.propTypes = {
    TypeOf: PropTypes.object,
    input: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    meta: PropTypes.object.isRequired,
    focus: PropTypes.bool,
    defaultValue: PropTypes.string,
    isDisabled: PropTypes.bool,
    handleChange: PropTypes.func
};



export default FieldInput;
